import { create } from "zustand";
import type { PersonaQuestId } from "../lib/completeness";
import { dismissPersonaSetup } from "../lib/session-skip";

interface PersonaSetupStore {
  activeQuest: PersonaQuestId;
  dismissedUserId: string | null;
  setActiveQuest: (quest: PersonaQuestId) => void;
  dismiss: (userId: string) => void;
  reset: () => void;
}

export const usePersonaSetupStore = create<PersonaSetupStore>((set) => ({
  activeQuest: "gender",
  dismissedUserId: null,
  setActiveQuest: (quest) => set({ activeQuest: quest }),
  dismiss: (userId) => {
    dismissPersonaSetup(userId);
    set({ dismissedUserId: userId });
  },
  reset: () => set({ activeQuest: "gender", dismissedUserId: null }),
}));
